import React, { useEffect, useState } from "react";

let captcha_value = "";
const validateCaptcha = (userValue: string) => userValue === captcha_value;
const loadCaptchaEnginge = (numberOfCharacters: number, backgroundColor = "white", fontColor = "#2040A0") => {
  let retVal = "";
  let charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let length = numberOfCharacters;

  for (let i = 0, n = charset.length; i < length; ++i) {
    retVal += charset.charAt(Math.floor(Math.random() * n));
  }

  let captcha = retVal;
  captcha_value = captcha;

  let canvas = document.getElementById("canv") as any,
    ctx = canvas!.getContext("2d");

  let text = captcha;
  let lineheight = 30;

  let lines = text.split("\n");

  ctx.canvas.width = length * 25;
  ctx.canvas.height = lines.length * lineheight;

  ctx.fillStyle = backgroundColor;
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  ctx.textBaseline = "middle";
  ctx.font = "900 italic 22px Arial";
  ctx.fillStyle = fontColor;
  let xPosition = 0;
  for (let i = 0; i < length; i++) {
    let yPosition = Math.round(Math.random() * (15 - 12) + 12);
    ctx.fillText(retVal[i], xPosition, yPosition);
    xPosition += ctx.measureText(retVal[i]).width + 5; // Add spacing between characters
  }
};

const NUMBER_CAPTCHA = 6;

type PROPS = {
  onSuccess: (isValid: boolean) => void;
};
const AppCaptcha: React.FC<PROPS> = ({ onSuccess }) => {
  const [value, setValue] = useState("");
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    loadCaptchaEnginge(NUMBER_CAPTCHA);
  }, []);

  const onChangeValue = (captcha: string) => {
    setValue(captcha);

    if (validateCaptcha(captcha)) {
      onSuccess(true);
      if (!isError || captcha.length < 6) return;
      setIsError(false);
    } else {
      onSuccess(false);
      if (isError || captcha.length < 6) return;
      setIsError(true);
    }
  };

  const onRefreshCaptcha = () => {
    loadCaptchaEnginge(NUMBER_CAPTCHA);
    if (value.length) {
      setIsError(true);
      onSuccess(false);
    }
  };

  return (
    <div className="max-w-sm mx-auto text-center">
      <div className="flex items-center mb-5">
        <canvas id="canv" className="cursor-pointer" onClick={onRefreshCaptcha}></canvas>

        <div className="flex-1 relative">
          <input
            maxLength={6}
            className={`w-full border-1 ${isError ? "!border-red-800 outline-red-800" : ""}`}
            name="captcha"
            value={value}
            onChange={(e) => onChangeValue(e.target.value)}
          />
          {isError && <small className="absolute bottom-0 left-0 translate-y-5 text-red-800 text-xs">検証コードが正しくありません</small>}
        </div>
      </div>
      <small className="font-medium text-gray-500">＊文字をクリックすると他のパターンに変更できます</small>
    </div>
  );
};

export default AppCaptcha;
